import LocationVarsModel from "../Models/Variables/LocationVars.Model";
import { Opp, WorksheetCondition, WorksheetIfCondition, } from "../Components/Worksheets/Types/Worksheet.Interface";
import { InternalWorksheetComponentProps } from "../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component";
import { GetLocationVarFromVariables } from "@swivl-mono/helpers";

export enum Visibility {
	SHOW = "Show",
	HIDE = "Hide",
	DISABLED = "Disabled"
}
interface LocationVarProps {
	orgVariables: any;
	groupVariables: any;
	locationVariables: any;
	isLoaded: boolean;
}

interface LocationProps {
	groupId?: number;
	locationId?: number;

}
interface WorksheetComponentVisabilityProps extends LocationProps {
	hideIf?: WorksheetCondition;
	marginTop?: boolean;
	marginBottom?: boolean;
}
export function useVisibility(props: WorksheetComponentVisabilityProps): Visibility {
	const { hideIf } = props;
	const { orgVariables, groupVariables, locationVariables, isLoaded } =
		LocationVarsModel.useState((s) => s);
	// const variables = WorksheetsInternalModel.useStore(state => state.variables)
	if (!hideIf) { return Visibility.SHOW }
	if (hideIf) {
		if (checkCondition(hideIf, props, { orgVariables, groupVariables, locationVariables, isLoaded })) {
			return Visibility.HIDE
		};
	}
	// if (disableIf && checkCondition(disableIf, variables)) { return Visibility.DISABLED };
	return Visibility.SHOW;
}

export function classNameForRow(className: string, props: WorksheetComponentVisabilityProps, visibility: Visibility): string {
	let _className = className + " WorksheetRow";
	if (props.marginTop) { _className += " marginTop" }
	if (props.marginBottom) { _className += " marginBottom" }
	if (visibility === Visibility.HIDE) { return _className + " hideRow" }
	if (visibility === Visibility.DISABLED) { return _className + " disableRow" }
	return _className;
}

export function classNameForSideBarItem(className: string, visibility: Visibility): string {
	let _className = className + " WorksheetRow";

	if (visibility === Visibility.HIDE) { return _className + " hideRow" }
	if (visibility === Visibility.DISABLED) { return _className + " disableRow" }
	return _className;
}

export function checkCondition(condition: WorksheetCondition, props: LocationProps, locationVarProps: LocationVarProps): boolean {
	const { TYPE } = condition;
	if (TYPE === "IF") {
		return checkIfCondition(condition, props, locationVarProps);
	}
	if (TYPE === "OR") {
		const { OR } = condition;
		for (let i = 0; i < OR.length; i++) {
			if (checkCondition(OR[i], props, locationVarProps)) { return true }
		}
		return false;
	}
	if (TYPE === "AND") {
		const { AND } = condition;
		for (let i = 0; i < AND.length; i++) {
			if (!checkCondition(AND[i], props, locationVarProps)) { return false }
		}
		return true;
	}
	return false;
}




export function checkIfCondition(condition: WorksheetIfCondition, props: LocationProps, locationVarProps: LocationVarProps): boolean {
	const { IF, IS, TO } = condition;
	const { orgVariables, groupVariables, locationVariables, isLoaded } = locationVarProps;
	const variable = GetLocationVarFromVariables(
		isLoaded,
		orgVariables,
		groupVariables,
		locationVariables,
		IF,
		props.groupId,
		props.locationId
	) || { value: "" };
	// const variable = variables[IF] || "";

	if (IS === Opp.EQUAL) {
		if (variable?.value === TO) { return true } else { return false }
	}
	if (IS === Opp.NOT_EQUAL) {

		if (variable?.value !== TO) {

			return true
		} else { return false }
	}

	return false;
}